import { FUND_SIZES, MANAGER_EXP, ASSET_CLASSES } from "./constants";

export const Step3 = ({ f, setF, toggle, valid, busy, onBack, onSubmit }) => (
  <div className="rise">
    <h1 className="text-4xl sm:text-5xl mt-4 text-bone" style={{ fontWeight: 500 }}>Secondaries and funds</h1>

    <div className="mt-12">
      <h2 className="t-h2 text-bone">Are you interested in secondary opportunities?</h2>
      <p className="t-small text-muted-s mt-2">
        Secondary opportunities are a way to invest in private companies by purchasing
        existing positions from other members.
      </p>
      <div className="mt-4 grid grid-cols-2 gap-3">
        {[true, false].map((v) => (
          <button key={String(v)} className={`option-card ${f.secondary_interest === v ? "selected" : ""}`}
            onClick={() => setF({ ...f, secondary_interest: v })} data-testid={`onboarding-secondary-${v ? "yes" : "no"}`}>
            <span className="t-body">{v ? "Yes" : "No"}</span>
          </button>
        ))}
      </div>
    </div>

    <div className="mt-12">
      <h2 className="t-h2 text-bone">Are you interested in venture funds?</h2>
      <div className="mt-4 grid grid-cols-2 gap-3">
        {[true, false].map((v) => (
          <button key={String(v)} className={`option-card ${f.venture_funds === v ? "selected" : ""}`}
            onClick={() => setF({ ...f, venture_funds: v })} data-testid={`onboarding-funds-${v ? "yes" : "no"}`}>
            <span className="t-body">{v ? "Yes" : "No"}</span>
          </button>
        ))}
      </div>
    </div>

    {f.venture_funds && (
      <>
        <div className="mt-12">
          <h2 className="t-h2 text-bone">Venture fund sizes (optional)</h2>
          <p className="t-small text-muted-s mt-2">In USD.</p>
          <div className="mt-4 space-y-3">
            {FUND_SIZES.map((s) => (
              <button key={s} className={`option-card ${f.fund_sizes.includes(s) ? "selected" : ""}`}
                onClick={() => toggle("fund_sizes", s)} data-testid={`onboarding-fundsize-${s.replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}>
                <span className="t-body">{s}</span>
              </button>
            ))}
          </div>
        </div>
        <div className="mt-12">
          <h2 className="t-h2 text-bone">Manager experience (optional)</h2>
          <p className="t-small text-muted-s mt-2">Number of funds a GP has launched.</p>
          <div className="mt-4 space-y-3">
            {MANAGER_EXP.map((m) => (
              <button key={m} className={`option-card ${f.manager_experience === m ? "selected" : ""}`}
                onClick={() => setF({ ...f, manager_experience: f.manager_experience === m ? "" : m })}
                data-testid={`onboarding-managerexp-${m.charAt(0)}`}>
                <span className="t-body">{m}</span>
              </button>
            ))}
          </div>
        </div>
      </>
    )}

    <div className="mt-12">
      <h2 className="t-h2 text-bone">Other asset classes (optional)</h2>
      <p className="t-small text-muted-s mt-2">
        These asset classes are not yet available on the Solera member surface. Your
        preferences will help guide what may be added.
      </p>
      <div className="mt-4 space-y-3">
        {ASSET_CLASSES.map((a) => (
          <button key={a.id} className={`option-card ${f.other_asset_classes.includes(a.id) ? "selected" : ""}`}
            onClick={() => toggle("other_asset_classes", a.id)}
            data-testid={`onboarding-asset-${a.id.replace(/[^a-z]/gi, "-").toLowerCase()}`}>
            <span className="t-body block">{a.id}</span>
            <span className="t-small text-muted-s block mt-1">{a.desc}</span>
          </button>
        ))}
      </div>
    </div>

    <div className="flex gap-3 mt-12">
      <button className="btn-ghost" onClick={onBack} data-testid="onboarding-back-3-button">Back</button>
      <button className="btn-primary flex-1" disabled={!valid || busy}
        onClick={onSubmit} data-testid="onboarding-submit-button">{busy ? "Saving" : "Complete profile"}</button>
    </div>
  </div>
);
